// extracted by mini-css-extract-plugin
export default {"white":"#fff","notificationRed":"#ff4c68","primaryIcon":"#309df0","LoadingPlaceholderParent":"bcm_a bhs_wl","LoadingPlaceholder":"bcm_b bhs_h","loading-placeholder":"bcm_c"};